// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-container {
  background-color: var(--bg-color); 
  border-top: 1px solid var(--border-color);
  transition: all 0.3s ease;
}

.footer-container p {
  font-size: 13px;
  color: var(--muted-text) !important;
  font-weight: 400;
  letter-spacing: 0.5px;
}

/* Dark Mode Adjustment */
[data-theme="dark"] .footer-container {
  background-color: rgba(0, 0, 0, 0.2);
}

.analyze-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./src/styles/footer.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;EACjC,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB","sourcesContent":[".footer-container {\n  background-color: var(--bg-color); \n  border-top: 1px solid var(--border-color);\n  transition: all 0.3s ease;\n}\n\n.footer-container p {\n  font-size: 13px;\n  color: var(--muted-text) !important;\n  font-weight: 400;\n  letter-spacing: 0.5px;\n}\n\n/* Dark Mode Adjustment */\n[data-theme=\"dark\"] .footer-container {\n  background-color: rgba(0, 0, 0, 0.2);\n}\n\n.analyze-page {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
